/** 偽値を捨てて空白区切りに結合する。依存を増やさないための最小 cx。 */
export function cx(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ');
}
